import ErrorBgEn from 'assets/images/errorFallbackEn.svg';
import ErrorBgFr from 'assets/images/errorFallbackFr.svg';

import { useTranslation } from 'react-i18next';

import { Box, Typography, Button } from '@mui/material';

import { stylesError, stylesErrorTitle, stylesErrorContent } from '@/utils/globalStyles';

export function ErrorFallback() {
  const { t, i18n } = useTranslation('components');
  return (
    <Box
      sx={{ backgroundImage: `url(${i18n.language === 'fr' ? ErrorBgFr : ErrorBgEn})`, ...stylesError }}
      role='alert'
    >
      <Box component='h1' sx={stylesErrorTitle}>
        {t('errorFallback.title')}
      </Box>
      <Typography variant='h1' component='p'>
        {t('errorFallback.subtitle')}
      </Typography>
      <Typography variant='bodyXL' component='p' sx={stylesErrorContent}>
        {t('errorFallback.content')}
      </Typography>
      {/* TODO : Faire le lien */}
      <Button onClick={() => window.location.assign(window.location.origin)}>{t('errorFallback.back')}</Button>
      <br />
      {/* TODO : Faire le lien vers la liste des dossiers */}
      <Button href='/folders'>{t('errorFallback.folders')}</Button>
    </Box>
  );
}
